export const environment = {
  production: false,

  clientName: 'demo',
  apiGatewayFront: 'https://desingproveedores.desmedicos.com/',
  apiGatewayBackOffice: 'https://desingproveedores.desmedicos.com/',
  apiUrl: 'https://desingproveedores.desmedicos.com/',
  urlPath: 'https://desingproveedores.desmedicos.com/',
  customCss: false,
  // Whether or not to enable debug mode
  // Setting this to false will disable console output
  enableDebug: false,
  // siteKeyCaptcha: '6LdLtBsgAAAAAJksLT4W-TI-oRed7Uk9B8Y-EECB', DEMO
  // siteKeyCaptcha: '6LfL5fkfAAAAALmrMTjEg18wnQm5uR3ZNbBy-pL7' ZX

  siteKeyCaptcha: '6LeGxigpAAAAAFv4zC5ZfA9YPZIiyVLzqizaehKI',

  googleAnalyticsCode: 'UA-140785247-1',
};